module.exports = __webpack_public_path__ + "6691d80d980b9446b743e4d7593933b0.png";